var UrlParams = {

    getUrlParams: function(){
        return deparam(location.search.substr(1));
    },

    checkParamKeys: function(key){
        return key.includes('utm_');
    },

    createFormKeyValuePairs: function(params){
        var leadSourceName = params['utm_source'] + '-' + params['utm_campaign'] + '-' + params['utm_content'],
            leadSourceCategoryName = params['utm_medium'];

        PageCookies.setPageCookie('leadSourceName', leadSourceName);
        PageCookies.setPageCookie('leadSourceCategoryName', leadSourceCategoryName);

        return {
            inf_field_LeadSourceName: leadSourceName,
            inf_field_LeadSourceCategoryName: leadSourceCategoryName
        }
    }
};

var PageCookies = {

    getPageCookie: function(key){
        var value = "; " + document.cookie,
            parts = value.split("; " + key + "=");

        if (parts.length == 2) return parts.pop().split(";").shift();
    },

    setPageCookie: function(key, value){
        var today = new Date(),
            expiryDate = new Date(today.getFullYear(), today.getMonth(), today.getDate()+7);

        document.cookie = key + "=" + value + "; expires=" + expiryDate;
    },

    createFormKeyValuePairs: function(){
        var leadSourceName = PageCookies.getPageCookie('leadSourceName'),
            leadSourceCategoryName = PageCookies.getPageCookie('leadSourceCategoryName');

        return {
            inf_field_LeadSourceName: leadSourceName,
            inf_field_LeadSourceCategoryName: leadSourceCategoryName
        }
    }
};

var InfusionForm = {

    generateFormInput: function(key, value){
        return '<input type="hidden" name="' + key + '" value="' + value + '">'
    },

    appendFormInputs: function(){
        var urlParams = UrlParams.getUrlParams(),
            hasCookie = document.cookie.indexOf('leadSourceName'),
            formObject;

        // If there's no cookie and url params exist
        if(hasCookie > -1){
            formObject = PageCookies.createFormKeyValuePairs();
        }
        else {
            if (Object.keys(urlParams).length){
                formObject = UrlParams.createFormKeyValuePairs(urlParams);
            }
        }

        for(var key in formObject){
            if (!formObject.hasOwnProperty(key)) continue;

            $('.ajax-form').append(
                InfusionForm.generateFormInput(key, formObject[key])
            );
        }
    }
};

$(function(){
   InfusionForm.appendFormInputs();
});